"use strict";

exports.__esModule = true;
exports.ListView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = require("../../Theme");
var _whenModern = require("../../Theme/UiDesign/whenModern");
var _ListItemView = require("./ListItemView");
var _excluded = ["list", "selected", "children"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var SelectedListItemView = (0, _styledComponents["default"])(_ListItemView.ListItemView).withConfig({
  displayName: "ListView__SelectedListItemView",
  componentId: "sc-1vfrg3p-0"
})(["background:", ";", ""], (0, _Theme.val)("SelectedListItemBackground"), (0, _whenModern.whenModern)((0, _styledComponents.css)(["background:transparent;", "{background:", ";box-shadow:inset 0 0 0 1px ", ",", ";}"], _ListItemView.ListItemViewButton, (0, _Theme.val)("selectedBackground"), (0, _Theme.val)("selectedBorderColor"), (0, _Theme.val)("CardShadow"))));
var ListView = exports.ListView = /*#__PURE__*/function (_Component) {
  function ListView() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ListView, _Component);
  var _proto = ListView.prototype;
  _proto.renderListViewItem = function renderListViewItem(index, listItem) {
    var _onClick = this.props.onClick;
    return /*#__PURE__*/_react["default"].createElement(_ListItemView.ListItemViewButton, {
      onClick: function onClick(e) {
        if (_onClick) {
          e.stopPropagation();
          _onClick(listItem.id);
        }
      }
    }, listItem.label);
  };
  _proto.render = function render() {
    var _this = this;
    var _this$props = this.props,
      list = _this$props.list,
      selected = _this$props.selected,
      children = _this$props.children,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    if (children && !list) {
      return /*#__PURE__*/_react["default"].createElement(_ListItemView.ListViewWrapper, extra, children);
    }
    return /*#__PURE__*/_react["default"].createElement(_ListItemView.ListViewWrapper, extra, list && list.map(function (listItem, index) {
      return listItem.id === selected ? /*#__PURE__*/_react["default"].createElement(SelectedListItemView, {
        key: listItem.id
      }, _this.renderListViewItem(index, listItem)) : /*#__PURE__*/_react["default"].createElement(_ListItemView.ListItemView, {
        key: listItem.id
      }, _this.renderListViewItem(index, listItem));
    }), children);
  };
  return ListView;
}(_react.Component);